import clsx from 'clsx'
import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Container, Icon, Spinner, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import format from 'utils/dateFns/format'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import StatusIcon from '../StatusIcon'
import styles from 'modules/Finance/PaymentProfiles/List/subcomponents/List/payment-profiles-list.module.scss'
import { ROUTES } from 'constants/routes'

const List = ({ data = [], pagination, loading, onChangePage }) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const pathGen = useGeneratePathI18n()

  //@TODO refactor to UI-kit LIST component
  return (
    <>
      {!loading && data.length === 0 && (
        <EmptyResults
          className={styles['empty-results']}
          header={t('payment_profiles::empty_list')}
          text={' '}
        />
      )}
      {data.map(({ is_archived, status, title, id, contract, method, decline_reason }, i) => (
        <Container
          className={styles['row']}
          key={'profile-' + i}
          display={'flex'}
          flexJustify={'space-between'}
          flexAlign={'center'}
        >
          <Container display={'flex'} flexAlign={'flex-start'}>
            <div className={styles['row__icon']}>
              <StatusIcon status={is_archived ? 'declined' : status} breakpoints={breakpoints} />
            </div>
            <Container className={styles['word-break-container']}>
              <Typography
                noMargin
                color={'text-primary'}
                variant={breakpoints.sm ? 'p10' : 'p2'}
                component={
                  status !== 'new' ? (
                    <Link
                      to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_INVOICES, {
                        profileId: id,
                      })}
                      className={styles['row__title']}
                    >
                      {title}
                    </Link>
                  ) : (
                    <p>{title}</p>
                  )
                }
              />

              <Container display={'flex'} flexAlign={'center'} flexWrap={'wrap'}>
                {contract?.number && (
                  <>
                    <Typography
                      variant={breakpoints.sm ? 'p11' : 'p9'}
                      component={'span'}
                      noMargin
                      color={'secondary-grey'}
                    >
                      {contract.number}
                      {contract?.date && ` ${t('common::dated')} ` + format(contract.date * 1000)}
                    </Typography>{' '}
                    <Icon name={'dot'} size={'s'} color={'secondary-grey'} />
                  </>
                )}
                <Typography
                  variant={breakpoints.sm ? 'p11' : 'p9'}
                  component={'span'}
                  noMargin
                  color={'secondary-grey'}
                >
                  {t(`common::payment_methods.${method}`)}
                </Typography>{' '}
                <Icon name={'dot'} size={'s'} color={'secondary-grey'} />
                <Typography
                  variant={breakpoints.sm ? 'p11' : 'p9'}
                  component={'span'}
                  noMargin
                  color={'secondary-grey'}
                >
                  {is_archived
                    ? t(`payment_profiles::is_archived`)
                    : t(`payment_profiles::statuses.${status}`)}

                  {status === 'declined' && (
                    <span>
                      : <span className={styles['decline_reason']}>{decline_reason}</span>
                    </span>
                  )}
                </Typography>
              </Container>
            </Container>
          </Container>
          {status !== 'new' && (
            <div>
              {status === 'declined' ? (
                <Link
                  to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_EDIT, {
                    profileId: id,
                  })}
                  title={t('common::button_labels.edit')}
                >
                  <Icon name={'refresh'} size={'m'} color={'secondary-46'} />
                </Link>
              ) : (
                <Link
                  to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_INVOICES, {
                    profileId: id,
                  })}
                  title={t('payment_profiles::go_to_invoices')}
                >
                  <Icon name={'doc'} size={'m'} color={'Label-GU-Primary'} />
                </Link>
              )}
            </div>
          )}
        </Container>
      ))}
      {data.length > 0 && pagination.total !== data.length && (
        <div className={styles['pagination']}>
          <Container
            display={'flex'}
            flexAlign={'center'}
            flexJustify={'center'}
            className={styles['show-more__container']}
          >
            {pagination.total !== data.length && (
              <Button
                onClick={() => onChangePage(1)}
                className={clsx(styles['show-more__button'])}
                variant={'link'}
                color={'Label-GU-Primary'}
                startIcon={loading ? <Spinner width={16} color={'inherit'} /> : null}
                endIcon={<Icon name={'arrow1-down'} color={'inherit'} size={'s'} />}
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Container>
        </div>
      )}
      {data.length === 0 && loading && <GridSpinner />}
      <Container
        display={'flex'}
        flexAlign={'center'}
        flexJustify={'center'}
        className={styles['add-button-container']}
      >
        <Button
          bgColor={'Label-GU-Primary'}
          component={Link}
          to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_NEW)}
          variant={'primary'}
          size={'m'}
          startIcon={<Icon name={'plus'} />}
        >
          {t('payment_profiles::add')}
        </Button>
      </Container>
    </>
  )
}

List.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  i18n: PropTypes.string,
}

export default List
